"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphQLDictionaryService = exports.queryError = void 0;
const graphql_request_client_1 = require("../graphql-request-client");
const constants_1 = require("../constants");
const dictionary_service_1 = require("./dictionary-service");
const graphql_1 = require("../graphql");
const debug_1 = __importDefault(require("../debug"));
/** @private */
exports.queryError = 'Valid value for rootItemId not provided and failed to auto-resolve app root item.';
const query = /* GraphQL */ `
  query DictionarySearch(
    $rootItemId: String!
    $language: String!
    $templates: String!
    $pageSize: Int = 10
    $after: String
  ) {
    search(
      where: {
        AND: [
          { name: "_path", value: $rootItemId, operator: CONTAINS }
          { name: "_language", value: $language }
          { name: "_templates", value: $templates, operator: CONTAINS }
        ]
      }
      first: $pageSize
      after: $after
    ) {
      total
      pageInfo {
        endCursor
        hasNext
      }
      results {
        key: field(name: "Key") {
          value
        }
        phrase: field(name: "Phrase") {
          value
        }
      }
    }
  }
`;
/**
 * Service that fetch dictionary data using Sitecore's GraphQL API.
 * @augments DictionaryServiceBase
 * @mixes SearchQueryService<DictionaryQueryResult>
 */
class GraphQLDictionaryService extends dictionary_service_1.DictionaryServiceBase {
    /**
     * Creates an instance of graphQL dictionary service with the provided options
     * @param {GraphQLDictionaryService} options instance
     */
    constructor(options) {
        super(options);
        this.options = options;
        this.graphQLClient = this.getGraphQLClient();
        this.searchService = new graphql_1.SearchQueryService(this.graphQLClient);
    }
    /**
     * Fetches dictionary data for internalization.
     * @param {string} language the language to fetch
     * @default query (@see query)
     * @returns {Promise<DictionaryPhrases>} dictionary phrases
     * @throws {Error} if the app root was not found for the specified site and language.
     */
    fetchDictionaryData(language) {
        return __awaiter(this, void 0, void 0, function* () {
            const cacheKey = this.options.siteName + language;
            const cachedValue = this.getCacheValue(cacheKey);
            if (cachedValue) {
                debug_1.default.dictionary('using cached dictionary data for %s %s', language, this.options.siteName);
                return cachedValue;
            }
            debug_1.default.dictionary('fetching site root for %s %s', language, this.options.siteName);
            // If the caller does not specify a root item ID, then we try to figure it out
            const rootItemId = this.options.rootItemId ||
                (yield graphql_1.getAppRootId(this.graphQLClient, this.options.siteName, language, this.options.jssAppTemplateId));
            if (!rootItemId) {
                throw new Error(exports.queryError);
            }
            debug_1.default.dictionary('fetching dictionary data for %s %s', language, this.options.siteName);
            const phrases = {};
            yield this.searchService
                .fetch(query, {
                rootItemId,
                language,
                templates: this.options.dictionaryEntryTemplateId || constants_1.SitecoreTemplateId.DictionaryEntry,
                pageSize: this.options.pageSize,
            })
                .then((results) => {
                results.forEach((item) => (phrases[item.key.value] = item.phrase.value));
            });
            this.setCacheValue(cacheKey, phrases);
            return phrases;
        });
    }
    /**
     * Gets a GraphQL client that can make requests to the API. Uses graphql-request as the default
     * library for fetching graphql data (@see GraphQLRequestClient). Override this method if you
     * want to use something else.
     * @returns {GraphQLClient} implementation
     */
    getGraphQLClient() {
        if (!this.options.endpoint) {
            if (!this.options.clientFactory) {
                throw new Error('You should provide either an endpoint and apiKey, or a clientFactory.');
            }
            return this.options.clientFactory({
                debugger: debug_1.default.dictionary,
                retries: this.options.retries,
            });
        }
        return new graphql_request_client_1.GraphQLRequestClient(this.options.endpoint, {
            apiKey: this.options.apiKey,
            debugger: debug_1.default.dictionary,
            retries: this.options.retries,
        });
    }
}
exports.GraphQLDictionaryService = GraphQLDictionaryService;
